import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserBackendService } from '../adapter/user-backend.service';
import { User } from '../entity/user.interface';
@Injectable({
  providedIn: 'root',
  useClass: UserBackendService,
})
export abstract class UserService {
  abstract fetch(userId: string, bearerToken: string): Observable<User>;
  abstract create(user: User, bearerToken: string): Observable<void>;

  // delete(user: User): Observable<void> {};
  // update(user: User): Observable<void> {};
}
